import { Component, OnInit, ViewChild } from "@angular/core";
import { AuthenticationService, UserService } from "../../../../auth/service";
import { locale as italian } from "../../../../i18n/it";
import { ActivatedRoute, ParamMap, Router } from "@angular/router";
import { UtilsService } from "../../../../auth/service/utils.service";
import { UserFigureService } from "../../../../auth/service/user-figure.service";
import { RoleService } from "app/auth/service/role.service";
import { CitiesService } from "../../../../auth/service/cities.service";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { ExportExcelComponent } from "../../../../layout/components/modals/export-excel/export-excel.component";
import { ExportExcelService } from "../../../../auth/service/export-excel.service";
import { ICity } from "app/auth/models/cities";
import { IContentHeader } from "app/layout/components/content-header/content-header.component";
import { SkillsService } from "../../../../auth/service/skills.service";

@Component({
  selector: "app-user-list",
  templateUrl: "./user-list.component.html",
  styleUrls: ["./user-list.component.scss"]
})
export class UserListComponent implements OnInit {
  private usersList: any = [];
  public contentHeader: IContentHeader;
  public tableLimit: number = 10;
  public filter_figure: string = "all";
  public filter_role: string = "all";
  public filter_string: string = "";
  public filter_skill: number[] = [0];
  public filteredUsers: any = [];
  public user_type: string = "";
  public currentUser: any = {};
  public user_type_name: string = italian.data.TITLES.USERS;
  public user_type_name_singular: string = italian.data.TITLES.USERS;
  public filter_onboarding: any = "all";
  public citiesList: ICity[] = null;
  public pageNumber: number = 0;

  @ViewChild("editCompanyEmailModal") editCompanyEmailModal: any;
  public editingCompanyEmail: { hash: string; email: string; } | null = null;

  constructor(
    public _userFigureService: UserFigureService,
    public _authenticationService: AuthenticationService,
    public _userService: UserService,
    public _utilService: UtilsService,
    private router: Router,
    private activated_route: ActivatedRoute,
    public _roleService: RoleService,
    public _citiesService: CitiesService,
    public _modalService: NgbModal,
    private _exportExcelService: ExportExcelService,
    public _skillService: SkillsService
  ) {
    this._utilService.disableAutoHideLoading();
    this.activated_route.queryParams.subscribe((params) => {
      const searchKey = params.search;
      const figure = params.figure;
      const role = params.role;
      const onboarding = params.onboarding;
      const page = params.page;

      if (!!searchKey && searchKey != 0) {
        this.filter_string = searchKey;
      }
      if (!!figure) {
        this.filter_figure = figure;
      }
      if (!!role) {
        this.filter_role = role;
      }
      if (!!onboarding) {
        this.filter_onboarding = Number(onboarding);
      }
      if (!!page) {
        this.pageNumber = page;
      }
    });
    this.activated_route.paramMap.subscribe(async (params: ParamMap) => {
      if (params.has("user_type")) {
        this.user_type = params.get("user_type");
        if (!this._authenticationService.hasCapability(`show_menu_${this.user_type}_list`)) {
          this._utilService.hideLoading();
          await this.router.navigateByUrl("/dashboard/main");
          return false;
        }
        this.contentHeader = {
          headerTitle: this.user_type_name,
          actionButton: false,
          breadcrumb: {
            type: "",
            links: [
              {
                name: "Home",
                isLink: true,
                link: "/"
              },
              {
                name: "MENU.USERS",
                isLink: false
              },
              {
                name: "TITLES.USERS",
                isLink: false
              }
            ]
          }
        };
        await this.loadList();
      } else {
        this._utilService.hideLoading();
        await this.router.navigateByUrl("/dashboard/main");
        return false;
      }
    });
  }

  async ngOnInit() {
    await this._skillService.getList();
    this.citiesList = await this._citiesService.getList();
  }

  async loadList() {
    this.currentUser = this._authenticationService.getCurrentUser();
    let selectFields: string = "avatar,firstname,lastname,complete_name,hash,figure,working_city,send_onboarding,skills,email";
    if (this._authenticationService.hasCapability("view_user_role")) {
      selectFields += ",role";
    }
    await this._userService.getList(this.user_type, null, 1, selectFields).then(async (r) => {
      this.usersList = r;
      this.getItems();
      this.user_type_name = await this._utilService.translate(italian.data.TITLES.USERS_TYPES[this.user_type]);
      this.user_type_name_singular = await this._utilService.translate(italian.data.TITLES.USERS_TYPES_SINGULAR[this.user_type]);
      this.contentHeader.headerTitle = this.user_type_name;
      this.contentHeader.breadcrumb.links[2].name = this.user_type_name;
    });
    this._utilService.hideLoading();
  }

  async openExportModal() {
    // extract labels and remove 'hash' field
    const uniqueLabels = await this._utilService.basic_get("/get-export-columns/v_user_complete").then((result: any) => result.columns || [])
      .then((labels: string[]) => labels.filter((label: string) => label !== "status" && !label.includes("id_") && !label.includes("_id") && !label.includes("hash")));
    //save in service labels and data to subscribe to export modal
    this._exportExcelService.labels.next(uniqueLabels);
    // set up data to export
    this._userService.getList(this.user_type, null, 1, uniqueLabels.join(","))
      .then((users: any) => this._exportExcelService.dataForExport.next(users));
    // set the file name
    this._exportExcelService.fileName.next("export-user");
    // set the area
    this._exportExcelService.area.next("employee");

    this._modalService.open(ExportExcelComponent, {
      centered: true,
      size: "lg",
      backdrop: false,
      keyboard: false
    });
  }

  changeSkill() {
    if (this.filter_skill.includes(0) && this.filter_skill.length >= 2 && this.filter_skill[this.filter_skill.length - 1] === 0) {
      //Se include zero significa che è stata selezionata l'opzione tutte le skill, anche se l'ultimo elemento è zero
      this.filter_skill = [0];
    } else {
      if (this.filter_skill.length > 1) {
        this.filter_skill = this.filter_skill.filter((skill) => skill !== 0);
      } else if (this.filter_skill.length < 1) {
        this.filter_skill = [0];
      }
      this.getItems();
    }
  }

  getItems() {
    let filteredItems: any = this.usersList.sort((a, b) => (a.lastname > b.lastname ? 1 : -1));
    const keyword: string = this.filter_string.toLowerCase();
    if (keyword.length > 1) {
      filteredItems = filteredItems.filter(
        (item: any) => item.complete_name.toLowerCase().includes(keyword) || (item.working_city || "").toLowerCase().includes(keyword) || item.number.toLowerCase().includes(keyword) || item.hash === keyword
      );
    }

    if (this.filter_figure && this.filter_figure.length > 0 && this.filter_figure !== "all") {
      filteredItems = filteredItems.filter((item: any) => item.figure === this.filter_figure);
    }

    if (this.filter_role && this.filter_role.length > 0 && this.filter_role !== "all") {
      filteredItems = filteredItems.filter((item: any) => item.role === this.filter_role);
    }
    if (this.filter_onboarding !== "all") {
      filteredItems = filteredItems.filter((item: any) => item.send_onboarding == this.filter_onboarding);
    }

    if (!this.filter_skill.includes(0)) {
      filteredItems = filteredItems.filter((item: any) => {
        return item.skills.map((s: any) => s.skill_id).some((id: number) => this.filter_skill.includes(id));
      });
    }

    this.filteredUsers = filteredItems;
  }

  changeQueryParams() {
    const url = new URL(window.location.href);

    if (!!this.filter_string && this.filter_string.length >= 3) {
      url.searchParams.set("search", this.filter_string);
      history.pushState({}, "", url);
    } else {
      url.searchParams.delete("search");
      history.pushState({}, "", url);
    }

    if (!!this.filter_figure && this.filter_figure.length > 0 && this.filter_figure !== "all") {
      url.searchParams.set("figure", this.filter_figure);
      history.pushState({}, "", url);
    } else {
      url.searchParams.delete("figure");
      history.pushState({}, "", url);
    }

    if (this.filter_role && this.filter_role.length > 0 && this.filter_role !== "all") {
      url.searchParams.set("role", this.filter_role);
      history.pushState({}, "", url);
    } else {
      url.searchParams.delete("role");
      history.pushState({}, "", url);
    }

    if (this.filter_onboarding && this.filter_onboarding !== "all") {
      url.searchParams.set("onboarding", String(this.filter_onboarding));
      history.pushState({}, "", url);
    } else {
      url.searchParams.delete("onboarding");
      history.pushState({}, "", url);
    }
  }

  updateTableLimit(event: any) {
    this.tableLimit = Number(event.target.value);
  }

  async deleteUser(hash: string) {
    if (!this._authenticationService.hasCapability("delete_user")) {
      this._utilService.hideLoading();
      await this.router.navigateByUrl("/dashboard/main");
      return false;
    }

    await this._utilService
      .showSWAL({
        title: "CONFIRM_DELETE_TITLE",
        text: "CONFIRM_DELETE_USER_TEXT",
        icon: "warning",
        confirmButtonText: "CONFIRM_DELETE_BTN",
        customClass: {
          confirmButton: "btn btn-danger"
        }
      })
      .then(async (result) => {
        if (result.value) {
          await this._userService.delete(hash).then(async () => {
            await this._utilService.showPopupItemDeleted("DELETED_USER_TEXT").then(() => this.loadList());
          });
        }
      });
  }

  async sendMailCredentials(hash: string) {
    try {
      await this._userService.sendEmailCredentials(hash);
      return await this._utilService.showSWALSuccess({ text: "SUCCESS_SEND_EMAIL_CREDENTIALS" });
    } catch (e) {
      return this._utilService.showSWALError({ text: "ERROR_SEND_EMAIL_CREDENTIALS" });
    }
  }

  openEditCompanyEmail(hash: string, email: string) {
    this.editingCompanyEmail = { hash, email };
    this._modalService.open(this.editCompanyEmailModal, {
      centered: true,
      size: "md",
      backdrop: false,
      keyboard: false
    });
  }

  closeEditCompanyEmail() {
    this.editingCompanyEmail = null;
    this._modalService.dismissAll();
  }

  updateEmailCompany() {
    if (!this._authenticationService.hasCapability("edit_user_company_email")) {
      return false;
    }
    this._utilService.showLoading();
    return this._userService.updateEmployeeCompanyEmail(this.editingCompanyEmail.hash, this.editingCompanyEmail.email)
      .then(() => {
        this.closeEditCompanyEmail();
        this._utilService.hideLoading();
        return this._utilService.showToastrSuccess("SUCCESS_UPDATE_COMPANY_EMAIL");
      })
      .catch(() => {
        this._utilService.hideLoading();
        return this._utilService.showToastrError("ERROR_UPDATE_COMPANY_EMAIL");
      });
  }
}
